var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 27,
    viewBox: "0 0 40 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.91162V25.2088L12.7155 12.544L0 1.91162Z",
    fill: "#172853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4692 12.544L39.1847 25.2088V1.91162L26.4692 12.544Z",
    fill: "#172853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5926 18.2411L14.1145 13.6982L1.43823 26.3242H37.7469L25.0706 13.6982L19.5926 18.2411Z",
    fill: "#172853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5923 15.89L37.8251 0.675903H1.35962L19.5923 15.89Z",
    fill: "#172853"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.d793f6056d481ca28d0239be9a14fa09.svg";
export { ForwardRef as ReactComponent };